var React = require('react');

function Pause (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1015_31613)","key":0},React.createElement("path",{"d":"M13.8039 1.27832H11.2941C10.6002 1.27832 10.0392 1.32995 10.0392 1.9237V15.6918C10.0392 16.2855 10.6002 16.3371 11.2941 16.3371H13.8039C14.4979 16.3371 15.0588 16.2855 15.0588 15.6918V1.9237C15.0588 1.32995 14.4979 1.27832 13.8039 1.27832ZM3.76471 1.27832H1.2549C0.560941 1.27832 0 1.32995 0 1.9237V15.6918C0 16.2855 0.560941 16.3371 1.2549 16.3371H3.76471C4.45867 16.3371 5.01961 16.2855 5.01961 15.6918V1.9237C5.01961 1.32995 4.45867 1.27832 3.76471 1.27832Z","fill":"#FCFCFC"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1015_31613"},React.createElement("rect",{"width":"15.0588","height":"16","fill":"white","transform":"translate(0 0.77002)"})))]);
}

Pause.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = Pause;

Pause.default = Pause;
